import { render, staticRenderFns } from "./OutboundAdd.vue?vue&type=template&id=71097098&scoped=true"
import script from "./OutboundAdd.vue?vue&type=script&lang=js"
export * from "./OutboundAdd.vue?vue&type=script&lang=js"
import style0 from "./OutboundAdd.vue?vue&type=style&index=0&id=71097098&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71097098",
  null
  
)

export default component.exports